<app-dialog-base class="modalreporttemplate" [Title]='"Report template"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="inputgroup">
    <label>{{'Name'|translate }}</label>
    <input type="text" placeholder="{{'Name'|translate }}" [(ngModel)]="model.Name" />
  </div>
  <div class="inputgroup">
    <label>{{'Type'|translate }}</label>
    <select [(ngModel)]="reportType" (change)="onReportChange()">
      <option *ngFor="let reportType of reportTypes | keyvalue" [selected]="model.Type == reportType.key"
        value="{{reportType.key}}">
        {{reportType.value|translate}}
      </option>
    </select>

  </div>
  <div class="inputgroup" *ngIf="containers.length">
    <label>{{'Container'|translate}}</label>
    <input *ngIf="isEditMode" type="text" [value]="getSelectedContainerName()" readonly />
    <select *ngIf="!isEditMode" [(ngModel)]="model.ContainerId">
      <option *ngFor="let container of creatableContainers" [ngValue]="container.Id">{{container.Name}}</option>
    </select>
  </div>
  <div class="inputgroup">
    <label>{{'Grouping'|translate }}</label>
    <input type="checkbox" [(ngModel)]="model.GroupByObject" />
  </div>
  <div class="tablewrap report-columns-wrap-report-template">
    <div class="table tablewitharrows">
      <table fixedcols="[0, 1]" id="report_template_columns_settings">
        <tr>
          <th>&nbsp;</th>
          <!-- <th>
            <switch-all-checkbox [items]="columns" />
          </th> -->
          <th>{{'Column'|translate }}</th>
          <th>{{'Name'|translate }}</th>
          <th>{{'Sensor name'|translate }}</th>
          <th><button class="btn_img btn_graygray btn_plusorange" (click)="openAddColumnDialog()"
              title="{{'Add'|translate}}"></button></th>
        </tr>
        <tr *ngFor="let column of resColumns">
          <td>
            <button (click)="pullUp(column)" class="btn_img btn_graygray btn_up"></button>
            <button (click)="pullDown(column)" class="btn_img btn_graygray btn_down"></button>
          </td>
          <!-- <td>
            <input type="checkbox" [(ngModel)]="column.IsChecked" />
          </td> -->
          <td>{{ column.Description | translate }}</td>
          <td>
            <input type="text" [(ngModel)]="column.Name" />
          </td>
          <td>
            <input type="text" [(ngModel)]="column.Value" />
          </td>
          <td>
            <button class="btn_img btn_trush" data-toggle="tooltip" data-placement="top" title="{{'Delete'|translate}}" style="display: inline-block;background-position: center;width: 100%;"
              (click)="deleteColumn(column)"></button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</app-dialog-base>
<template #columnsListDialog></template>
